import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import store from "./app/redux/ReduxStore";
import "./assets/styles/index.css";
import { CartProvider } from './context/cart'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
<CartProvider>
  <App />
</CartProvider>
  </Provider>
);
